import type { ReactNode } from "react";

/** The product lockup that opens every front-door screen. */
export function BrandMark() {
  return (
    <div className="flex items-center gap-2.5">
      <span className="flex size-8 items-center justify-center rounded-sm bg-accent text-lg font-semibold text-fg-on-accent">
        A
      </span>
      <div className="flex flex-col">
        <span className="text-md leading-[18px] font-semibold">auradata</span>
        <span className="text-xs leading-[14px] text-fg-subtle">
          Managed dbt for your warehouse
        </span>
      </div>
    </div>
  );
}

/** The card the front-door screens live in: white surface, border, card shadow. */
export function AuthCard({ children }: { children: ReactNode }) {
  return (
    <div className="flex flex-col gap-5 rounded-lg border border-border bg-surface p-6 shadow-card">
      {children}
    </div>
  );
}

/**
 * The signed-out canvas: one centered column, the legal footer pinned to the bottom.
 * `width` is the column width the design gives each screen (400 / 440 / 560px).
 */
export function AuthLayout({ width, children }: { width: number; children: ReactNode }) {
  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center bg-canvas px-4 py-12">
      <div className="flex w-full flex-col gap-4" style={{ maxWidth: width }}>
        {children}
      </div>
      <div className="absolute inset-x-0 bottom-0 flex px-8 py-4 text-sm text-fg-subtle">
        <span className="flex-1" />
        <span>© {new Date().getFullYear()} auradata</span>
      </div>
    </div>
  );
}
